import { gql } from '@apollo/client';

export const FETCH_CONTRACT_LANGUAGE = gql`
  query Flex_FetchContractLanguage($contractVersionId: Int!, $languageShortCode: String!) {
    contractVersion(id: $contractVersionId) {
      id
      contractVersionLanguage(languageShortCode: $languageShortCode) {
        id
      }
    }
  }
`;
